import { EntityPhaseItem, EntityPhaseList } from '../../../Entity'
import {
  getRequestPhaseStatusText,
  getTooltipAdditionalText,
  RequestPhaseInput,
} from '../../../Request'
import { Container } from '../../Container'

function RequestsPhase() {
  return (
    <>
      <Container label='Request phase item, base'>
        <EntityPhaseItem
          getPhaseStatusText={getRequestPhaseStatusText}
          getTooltipAdditionalText={getTooltipAdditionalText}
          name='First phase'
        />
      </Container>
      <Container label='Request phase item, with back part'>
        <EntityPhaseItem
          backPart
          getPhaseStatusText={getRequestPhaseStatusText}
          getTooltipAdditionalText={getTooltipAdditionalText}
          name='First phase'
        />
      </Container>
      <Container label='Request phase item, with front part'>
        <EntityPhaseItem
          frontPart
          getPhaseStatusText={getRequestPhaseStatusText}
          getTooltipAdditionalText={getTooltipAdditionalText}
          name='First phase'
        />
      </Container>
      <Container label='Request phase item, with back & front parts'>
        <EntityPhaseItem
          backPart
          frontPart
          getPhaseStatusText={getRequestPhaseStatusText}
          getTooltipAdditionalText={getTooltipAdditionalText}
          name='First phase'
        />
      </Container>
      <Container label='Request phase item, with back & front parts, selected'>
        <EntityPhaseItem
          backPart
          frontPart
          selected
          getPhaseStatusText={getRequestPhaseStatusText}
          getTooltipAdditionalText={getTooltipAdditionalText}
          name='First phase'
        />
      </Container>
      <Container label='Request phases'>
        <EntityPhaseList
          getPhaseStatusText={getRequestPhaseStatusText}
          getTooltipAdditionalText={getTooltipAdditionalText}
          items={[
            { id: 0, name: 'First phase', progress: 50 },
            { id: 1, name: 'Second phase', progress: 0 },
            { id: 2, name: 'Third phase', progress: 0 },
          ]}
        />
      </Container>
      <Container
        label='Request phases, with horizontal scroll'
        style={{ maxWidth: 625 }}
      >
        <EntityPhaseList
          getPhaseStatusText={getRequestPhaseStatusText}
          getTooltipAdditionalText={getTooltipAdditionalText}
          items={[
            { id: 0, name: 'First phase', progress: 100 },
            { id: 1, name: 'Second phase', progress: 50 },
            { id: 2, name: 'Third phase', progress: 0 },
            { id: 3, name: 'Fourth phase', progress: 0 },
            { id: 4, name: 'Fifth phase', progress: 0 },
            { id: 5, name: 'Sixth phase', progress: 0 },
          ]}
        />
      </Container>
      <Container label='Request phases input, empty'>
        <RequestPhaseInput emptyText='Please, select service request first' />
      </Container>
      <Container label='Request phases input, loading'>
        <RequestPhaseInput isLoading />
      </Container>
      <Container label='Request phases input, with items'>
        <RequestPhaseInput
          items={[
            { id: 0, name: 'First phase', progress: 100 },
            { id: 1, name: 'Second phase', progress: 50 },
            { id: 2, name: 'Third phase', progress: 0 },
            { id: 3, name: 'Fourth phase', progress: 0 },
          ]}
        />
      </Container>
      <Container label='Request phases input, with items, error'>
        <RequestPhaseInput
          error
          items={[
            { id: 0, name: 'First phase', progress: 100 },
            { id: 1, name: 'Second phase', progress: 50 },
            { id: 2, name: 'Third phase', progress: 0 },
            { id: 3, name: 'Fourth phase', progress: 0 },
          ]}
        />
      </Container>
    </>
  )
}

export default RequestsPhase
